import {
    Component,
    OnInit,
    OnDestroy,
    Renderer2,
    HostBinding
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from '@services/app.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
    @HostBinding('class') class = 'login-box';
    public loginForm: UntypedFormGroup;
    public isAuthLoading = false;
    public loginError = false;
    public showPassword = false;
    public usernameFocused = false;
    public passwordFocused = false;
    public loginResponse: any;
    public userType: string;

    constructor(
        private renderer: Renderer2,
        private toastr: ToastrService,
        private appService: AppService,
        private router: Router
    ) { }

    ngOnInit() {
        this.renderer.addClass(
            document.querySelector('app-root'),
            'login-page'
        );
        this.loginForm = new UntypedFormGroup({
            username: new UntypedFormControl(null, Validators.required),
            password: new UntypedFormControl(null, Validators.required)
        });
    }

    loginDetails() {
        if (!this.loginForm.valid) {
            this.toastr.error('Please enter username and password');
            return;
        }
        const loginData = { ...this.loginForm.value };
        if (loginData.username) {
            loginData.username = loginData.username;
        }
        this.isAuthLoading = true;
        this.loginError = false;
        console.log('User details:', loginData);
        this.appService.loginUserData(loginData)
            .subscribe({
                next: (response) => {
                    this.isAuthLoading = false;
                    console.log('User Login successfully', response);
                    this.loginResponse = response;
                    if (this.loginResponse?.authHeader) {
                        localStorage.setItem('authToken', this.loginResponse.authHeader);
                    }
                    if (this.loginResponse?.login?.userType) {
                        localStorage.setItem('lfUserType', this.loginResponse.login.userType);
                    }
                    if (this.loginResponse?.login?.registrationDetails?.whatsappNumber) {
                        localStorage.setItem('phoneNumber', this.loginResponse.login.registrationDetails.whatsappNumber);
                    }
                    this.userType = this.loginResponse?.login?.userType;
                    if (this.userType === 'ADMIN') {
                        this.toastr.success('Login successful!');
                        this.router.navigate(['dashboard']);
                    } else {
                        this.router.navigate(['dashboard']);
                        this.toastr.error('Access Denied!');
                    }
                },
                error: (error) => {
                    this.isAuthLoading = false;
                    this.loginError = true;
                    setTimeout(() => this.loginError = false, 3000);
                    console.error('Error Login user', error);
                    this.toastr.error(error.error?.message || 'Something went wrong, Please try again....');
                },
            });
    }

    ngOnDestroy() {
        this.renderer.removeClass(
            document.querySelector('app-root'),
            'login-page'
        );
    }
}
